export const DRAWER_DETAIL_BUTTON_CTA_TEXT = {
  OFFER: 'Get My Offer',
  APPRAISE: 'No thanks. I just want an appraisal',
  APPRAISE_ADDRESS_DRAWER: 'Get appraisal report without a VIN',
  APPRAISE_LINK: 'Get appraisal report without VIN',
};

export const DRAWER_TRIGGER_CTA_TEXT = {
  licensePlate: "Don't have your license plate?",
  vin: "Don't have your VIN?",
  address: 'Find my VIN',
};

export const WHERE_CAN_I_FIND_MY_VIN_TEXT = 'Where can I find my VIN?';
